"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_parental__control(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a18159d3-8ecd-41cc-ba74-ab342a33869c",
    "data-name": "Ebene 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a31150ff-2512-46e4-8d48-924afcbcc3a3",
    x1: -146.65,
    y1: 37.4,
    x2: -49.94,
    y2: 134.11,
    gradientTransform: "translate(215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "parental-control-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.81,8.81,0,0,1-3.59-.77c-12.76-5.64-76.49-38.83-76.49-137.39a8.42,8.42,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.64,10.64,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.45,8.45,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.92,8.92,0,0,1,96,176.22Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.81,8.81,0,0,1-3.59-.77c-12.76-5.64-76.49-38.83-76.49-137.39a8.42,8.42,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.64,10.64,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.45,8.45,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.92,8.92,0,0,1,96,176.22Zm-72-138.79a4.49,4.49,0,0,0,0,.63c0,93.6,59.76,124.78,71.74,130.08a.82.82,0,0,0,.67,0c12-5.31,71.79-36.51,71.79-130.09a4.71,4.71,0,0,0,0-.65c-1.28-.26-4.69.16-7.47.51-12,1.5-34.39,4.28-63.19-13.74h0a2.64,2.64,0,0,0-2.76,0c-28.81,18-51.19,15.25-63.21,13.76C28.62,37.59,25.2,37.17,23.92,37.43Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.81,8.81,0,0,1-3.59-.77c-12.76-5.64-76.49-38.83-76.49-137.39a8.42,8.42,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.64,10.64,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.45,8.45,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.92,8.92,0,0,1,96,176.22Zm-72-138.79a4.49,4.49,0,0,0,0,.63c0,93.6,59.76,124.78,71.74,130.08a.82.82,0,0,0,.67,0c12-5.31,71.79-36.51,71.79-130.09a4.71,4.71,0,0,0,0-.65c-1.28-.26-4.69.16-7.47.51-12,1.5-34.39,4.28-63.19-13.74h0a2.64,2.64,0,0,0-2.76,0c-28.81,18-51.19,15.25-63.21,13.76C28.62,37.59,25.2,37.17,23.92,37.43Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,35.19c-1.28-.26-4.69.17-7.47.51C148.55,37.2,126.18,40,97.38,22h0a2.64,2.64,0,0,0-2.76,0C65.81,40,43.43,37.21,31.41,35.72c-2.79-.34-6.21-.77-7.49-.51a4.61,4.61,0,0,0,0,.63c0,.6,0,1.19,0,1.78a1,1,0,0,1,0-.19c1.28-.26,4.7.16,7.49.51,12,1.49,34.4,4.27,63.21-13.76a2.64,2.64,0,0,1,2.76,0h0c28.8,18,51.17,15.24,63.19,13.74,2.78-.35,6.19-.77,7.47-.51a1,1,0,0,1,0,.19c0-.59,0-1.17,0-1.76A4.83,4.83,0,0,0,168,35.19Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,173.24a8.84,8.84,0,0,1-7.17,0C79.68,167.62,16.65,134.79,15.9,37.6c0,.15,0,.3,0,.46,0,98.56,63.73,131.75,76.49,137.39a8.81,8.81,0,0,0,3.59.77,8.92,8.92,0,0,0,3.58-.76c12.78-5.66,76.54-38.86,76.54-137.39,0-.17,0-.32,0-.49C175.32,134.76,112.24,167.62,99.54,173.24Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77,89",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38,92.6",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b0589d54-4a10-4c05-9bec-91139f61aa17",
    "data-name": "<Path>",
    cx: 82.71,
    cy: 64.64,
    r: 20.64,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e44c092c-1d1c-41a7-b39a-7001e50e9ac5",
    "data-name": "<Path>",
    d: "M108.33,123.47a6.51,6.51,0,0,0,5-8c-5.2-20.58-16.63-30.18-30.38-30.18S55,94.88,49.71,115.45a6.5,6.5,0,0,0,5,8,138.57,138.57,0,0,0,28.11,2.88A113.66,113.66,0,0,0,108.33,123.47Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1664ed1-4b1b-4083-8dbd-3b7d7ce51952",
    "data-name": "<Path>",
    d: "M108.33,123.47a6.51,6.51,0,0,0,5-8c-5.2-20.58-16.63-30.18-30.38-30.18S55,94.88,49.71,115.45a6.5,6.5,0,0,0,5,8,138.57,138.57,0,0,0,28.11,2.88A113.66,113.66,0,0,0,108.33,123.47Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf4c6301-dfc8-4381-b90b-8bf8c5f36817",
    "data-name": "<Path>",
    d: "M108.33,123.47a6.51,6.51,0,0,0,5-8c-5.2-20.58-16.63-30.18-30.38-30.18S55,94.88,49.71,115.45a6.5,6.5,0,0,0,5,8,138.57,138.57,0,0,0,28.11,2.88A113.66,113.66,0,0,0,108.33,123.47Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "912d09e7-8157-4963-a80f-cb135ef2b45b",
    "data-name": "<Path>",
    cx: 82.71,
    cy: 64.64,
    r: 20.64,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ada919e7-cbf0-4a70-8dd0-63025e9ec737",
    "data-name": "<Path>",
    cx: 120.15,
    cy: 70.13,
    r: 15.13,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd53180f-e4b5-4545-834a-6b28c915d7ae",
    "data-name": "<Path>",
    d: "M140.71,113.44a4.77,4.77,0,0,0,3.64-5.87c-3.81-15.08-14-22.12-24-22.12s-20.48,7-24.34,22.11a4.77,4.77,0,0,0,3.64,5.88,101.46,101.46,0,0,0,20.6,2.11A102.11,102.11,0,0,0,140.71,113.44Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb62a611-ac9d-4200-8430-2e976eb9278c",
    "data-name": "<Path>",
    d: "M140.71,113.44a4.77,4.77,0,0,0,3.64-5.87c-3.81-15.08-14-22.12-24-22.12s-20.48,7-24.34,22.11a4.77,4.77,0,0,0,3.64,5.88,101.46,101.46,0,0,0,20.6,2.11A102.11,102.11,0,0,0,140.71,113.44Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "c023875c-9b97-4b1a-a68f-d02b0f2fee03",
    "data-name": "<Path>",
    d: "M140.71,113.44a4.77,4.77,0,0,0,3.64-5.87c-3.81-15.08-14-22.12-24-22.12s-20.48,7-24.34,22.11a4.77,4.77,0,0,0,3.64,5.88,101.46,101.46,0,0,0,20.6,2.11A102.11,102.11,0,0,0,140.71,113.44Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "43139dcf-e943-4e93-975b-19adbe8165b9",
    "data-name": "<Path>",
    cx: 120.15,
    cy: 70.13,
    r: 15.13,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "fb9bd275-a283-4396-8539-c22c1b64b374",
    "data-name": "<Path>",
    cx: 120.15,
    cy: 70.13,
    r: 15.13,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "129eeaa3-51fb-42ac-8fdd-e7bfcbdbd52b",
    "data-name": "<Path>",
    d: "M140.71,113.44a4.77,4.77,0,0,0,3.64-5.87c-3.81-15.08-14-22.12-24-22.12s-20.48,7-24.34,22.11a4.77,4.77,0,0,0,3.64,5.88,101.46,101.46,0,0,0,20.6,2.11A102.11,102.11,0,0,0,140.71,113.44Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "31b2f60b-cfb3-4ddf-95cb-67b1cb68c3ce",
    "data-name": "<Path>",
    cx: 120.15,
    cy: 70.13,
    r: 15.13,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c690e139-b2dc-4cfe-8826-d072d5d14e35",
    "data-name": "<Path>",
    cx: 96,
    cy: 92.1,
    r: 13.52,
    fill: "#e60100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8d2c15cc-c7e0-48b7-b232-1f977859326b",
    "data-name": "<Path>",
    d: "M114.36,130.62a4.27,4.27,0,0,0,3.26-5.24c-3.41-13.48-12.48-19.77-21.49-19.77s-18.29,6.29-21.74,19.76a4.26,4.26,0,0,0,3.25,5.25A90.93,90.93,0,0,0,96,132.5,90.24,90.24,0,0,0,114.36,130.62Z",
    transform: "translate(0 0)",
    fill: "#e60100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,175.46c12.78-5.66,76.54-38.86,76.54-137.39a8.45,8.45,0,0,0-2.58-6.67c-3.12-2.76-7.65-2.2-13.92-1.42-11.81,1.47-31.57,3.93-58-12.58A10.58,10.58,0,0,0,96,15.8V176.21A8.69,8.69,0,0,0,99.54,175.46Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a31150ff-2512-46e4-8d48-924afcbcc3a3)"
  }));
}

var _default = ic_parental__control;
exports.default = _default;